import React from 'react'
import PropTypes from 'prop-types'
// import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Button as BaseButton } from 'antd'

export default class Button extends React.Component {
  render() {
    const { intl, name = 'submit', size = 'large', ...restProps } = this.props
    return (
      <BaseButton size={size} {...restProps}>
        <FormattedMessage {...messages[`${name}`]} />
      </BaseButton>
    )
  }
}

Button.propTypes = {
  name: PropTypes.oneOf(['submit', 'pay', 'back', 'refresh']).isRequired
}
